import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import {
  FlexContainer,
  HorizontalTabs,
} from "../../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import variables from "../../../constants/assets/variables";
import SearchInputs from "../../../constants/Disputes/SearchInputs.json";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import InitialStates from "../../../constants/Disputes/initialstate.json";
import { bindActionCreators } from "redux";
import * as DisputesActions from "../../../store/actions/Disputes";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import constants from "../../../constants/Disputes/constants.json";
import Searchbox from "sushiweb/Searchbox";
import MenuItem from "sushiweb/MenuItem";
import * as UserActions from "../../../store/actions/User";

const keys = ["reported_for", "reported_for_id", "ref_id", "ref_type", "type"];
let dispute_types = [];
const options = { "reported_for": constants.reported_for_types, "ref_type": constants.ref_types };

function removeUnrelatedFilters(curFilters, curKey) {
  if (curKey == "id") {
    keys.forEach((key) => {
      curFilters[key] = "";
    });
  }
  else {
    curFilters["id"] = "";
  }
}

function parseToRequestFilters(filters) {
  var finalFilter = {};
  if (filters.id) {
    finalFilter = {
      dispute_id: filters.id,
    };
    return finalFilter;
  }
  if ((filters.reported_for && !filters.reported_for_id) || (!filters.reported_for && filters.reported_for_id)) {
    if ((filters.ref_type && !filters.ref_id) || (!filters.ref_type && filters.ref_id)) {
      return { error: "Please select both ref id and ref type and reported for id and reported for" };
    }
    if (filters.type) {
      return { error: "Please select both reported for id and reported for" };
    }
    return { error: "Please select both reported for id and reported for" };
  }

  if (filters.reported_for_id && filters.reported_for) {
    finalFilter = {
      reported_for_id: filters.reported_for_id,
      reported_for: filters.reported_for
    };
    if ((filters.ref_type && !filters.ref_id) || (!filters.ref_type && filters.ref_id)) {
      return { error: "Please select both ref id and ref type" };
    }
    if (filters.ref_id && filters.ref_type) {
      finalFilter.ref_id = filters.ref_id;
      finalFilter.ref_type = filters.ref_type
    }
    if (filters.type) {
      finalFilter.type = filters.type
    }
    return finalFilter;
  }
  return { error: "No valid filters applied" };
}

const FilterSearchBar = ({ applyFilters, getDisputeTypes, resetState, setStatus }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [initialState, setInitialState] = useState({ ...InitialStates });
  const [disputeType, setDisputeType] = useState([]);
  const history = useHistory();
  const handleClick = (index) => (e) => {
    setActiveIndex(index);
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    removeUnrelatedFilters(values, key);
    setInitialState(values);
  };

  const handleSubmit = (e, action) => {
    e.preventDefault();
    resetState();
    if (action === "apply") {
      var filter;
      filter = parseToRequestFilters(initialState);
      if (filter.error) {
        setStatus({
          type: "error",
          message: filter.error,
        });
        return;
      }
      applyFilters(filter);
    }
    else {
      setInitialState({ ...InitialStates });
      setDisputeType(dispute_types);
    }
  };

  const checkIfButtonDisabled = (btnType) => {
    if (btnType === "apply") {
      if (initialState.id) {
        return false;
      }
      if ((initialState.reported_for_id && initialState.reported_for)) {
        var result = false;
        if (initialState.ref_id || initialState.ref_type)
          result = true;
        else if (initialState.type)
          result = false;
        if ((initialState.ref_id && initialState.ref_type))
          result = false;
        return result;
      }
      return true;
    }
    else
      return false;
  };

  const handleInputChange = (query) => {
    if (query == "") {
      setInitialState({ ...initialState, type: "" });
      setDisputeType(dispute_types);
      return;
    }
    const updatedtype = dispute_types.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    );
    setDisputeType(updatedtype);
  };

  const handleSearchBoxClick = () => {
    if (disputeType.length === 0) {
      if (dispute_types.length > 0)
        setDisputeType(dispute_types);
      else
        getDisputeTypes().then((res) => {
          if (res && res.dispute_types) {
            dispute_types = res.dispute_types;
            setDisputeType(dispute_types);
          }
        });
    }
  };

  return (
    <FilterSearchBox
      className="containsDropdown mr-10"
      onSubmit={(e) => handleSubmit(e, "apply")}
    >
      <HorizontalTabs className="mb-18">
        <HorizontalTabs.Link
          className="searchIndex"
          active={activeIndex === 0}
          onClick={handleClick(0)}
        >
          <span>
            Filter
          </span>
        </HorizontalTabs.Link>
      </HorizontalTabs>

      <React.Fragment>
        {SearchInputs.inputs.map((field, index) => {
          if (["reported_for", "ref_type"].includes(field.name))
            return (
              <PaginatedReactDropdown
                options={options[field.name]}
                labelKey="label"
                valueKey="key"
                labelWidth="fit-content"
                value={initialState[field.name]}
                handleChange={handleChange}
                keyToChange={field.name}
                placeholder={field.label}
                showCross={true}
                id="Dropdown"
              />
            );
          else if (["type"].includes(field.name))
            return (
              <SearchContainer>
                <Searchbox
                  onCloseIconClick={() => handleInputChange("")}
                  className="sushi-searchbox"
                  placeholder="Dispute Type"
                  onChange={handleInputChange}
                  onSelect={(e) => handleChange(field.name, e)}
                  showLeftIcon={false}
                  placeholderFont="17px"
                  value={initialState[field.name]}
                  onFocus={handleSearchBoxClick}
                >
                  {disputeType.map((type, index) => {
                    return <MenuItem key={index} value={type} label={type} />;
                  })}
                </Searchbox>
              </SearchContainer>
            ); else
            return (
              <Input
                onChange={(e) => handleChange(field.name, e)}
                value={initialState[field.name]}
                data-testid={`input-field-${field.name}`}
                key={index}
                type={field.isNumber ? "number" : undefined}
                id="sushi-input"
                label={field.label}
              />
            );
        }
        )}
      </React.Fragment>

      <FlexContainer>
        <Button
          onClick={(e) => handleSubmit(e, "clear")}
          disabled={checkIfButtonDisabled("clear")}
          className="sushi-btn"
          type="submit"
        >
          clear
        </Button>
        <Button
          onClick={(e) => handleSubmit(e, "apply")}
          disabled={checkIfButtonDisabled("apply")}
          className="sushi-btn"
          data-testid="filtersApply"
          type="submit"
        >
          Apply
        </Button>
      </FlexContainer>
    </FilterSearchBox>
  );
};

const FilterSearchBox = styled.form`
  padding: 18px;
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;

  #sushi-input {
    margin-bottom: 14px;
  }

  #Dropdown {
    margin-bottom: 22px;
    background : ${variables.grey50};
    height : 47px;
  }

  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon
    .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] {
    border-radius: 8px;
    padding: 10px 18px;
    box-sizing: border-box;
    height: unset;
  }
  .Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${variables.grey300};
  }
  .MuiFormLabel-root.Mui-focused {
    color: ${variables.grey700};
  }
  .MuiAutocomplete-popupIndicator {
    margin-right: 8px;
  }
  .cross {
    opacity: 0.5;
    width: 15px;
    height: auto;
    margin-right: 10px;
  }
  .MuiInputLabel-outlined {
    transform: translate(20px, 15px) scale(1);
    &.MuiInputLabel-shrink {
      transform: translate(10px, -8px) scale(0.8);
    }
  }
  .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]
    .MuiAutocomplete-input {
    padding: 2px 4px;
  }

  .partner_status_options > div {
    word-break: break-all;
  }
`;

const SearchContainer = styled.div`
  margin: 0 10px 20px;
  margin-left: 0px;
  & > div {
    width: 100%;
  } 
  & > div > div > div > div > div > div {
    background : ${variables.grey50};
    & > div {
      margin-left: 0px;
      input {
        background : ${variables.grey50};
        &::placeholder{
          color : ${variables.grey600};
          font-style : unset;
          font-size : 18px;
          font-weight : 400;
          margin-left : 0px;
        }
      }                 
    }     
  }
}
  
.sushi-searchbox {
  height: 50px !important;
  min-height: unset;
  & > div > div > div > div  {
    height: 50px !important;
  }
}
`;

function mapStateToProps(state) {
  return {

  };
}

function mapDispatchToProps(dispatch) {
  return {
    applyFilters: bindActionCreators(DisputesActions.getDisputesList, dispatch),
    getDisputeTypes: bindActionCreators(DisputesActions.getDisputeTypes, dispatch),
    resetState: bindActionCreators(DisputesActions.resetState, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterSearchBar);
